export default "__VITE_ASSET__9f25a5a7__"